<template>
    <div class="pjiejue">
        <div class="brief-bg" style="background: #5060e6;">
            <div class="brief-bg__word" :style="briefwordstyle">
                <h2 class="fadeInUp">虚拟电商解决方案</h2>
                <span class="fadeInUp">
                    帮助您建立去中心化的电商体系
                    <br>快速引爆线上流量
                </span>
            </div>
            <img src="/site_static/pimg/banner-img.png" alt="" :style="briefimg">
        </div>
        <div class="wake">
            <div class="page-info">
                <h2 :style="pageh2">基于社交圈低成本裂变营销</h2>
                <h3 :style="pageh3">社交场景与营销活动结合实现大爆炸式传播</h3>
                <img src="/site_static/pimg/img-2.png" alt="">
            </div>
        </div>
        <div class="distribute-model">
            <div  class="page-info">
                <h2 class="fadeInUp" :style="pageh2">社交电商多样化业务场景</h2>
                <h3 class="fadeInUp2" style="color: rgb(156, 158, 174);" :style="pageh3">您的一站式电商营销解决方案</h3>
            </div>
            <ul class="distribute-model__list">
                <li class="distribute-model__list__item">
                    <img src="/site_static/pimg/icon-1.png" >
                    <h4>会员群体</h4>
                    <span>了解会员洗好精准营销</span>
                </li>
                <li class="distribute-model__list__item">
                    <img src="/site_static/pimg/icon-2.png" >
                    <h4>营销活动</h4>
                    <span>多种营销玩法灵活销货</span>
                </li>
                <li class="distribute-model__list__item">
                    <img src="/site_static/pimg/icon-3.png" >
                    <h4>卡密拼团</h4>
                    <span>快速裂变推广分享</span>
                </li>
                <li class="distribute-model__list__item">
                    <img src="/site_static/pimg/icon-4.png" >
                    <h4>代理改价</h4>
                    <span>招募代理改价销售</span>
                </li>
            </ul>
        </div>
        <div style="    background: rgb(227, 242, 253);">
            <mu-carousel hide-controls>
                <mu-carousel-item>
                    <div  class="page-info">
                        <h2 class="fadeInUp" :style="pageh2">朋友圈口碑传播，建立个性电商</h2>
                        <h3 class="fadeInUp2" style="color: rgb(156, 158, 174);text-align: left;" :style="pageh3">依托微信10亿强社交网络，协助您推广宣传，快速打开电商市场</h3>
                    </div>
                    <img src="/site_static/pimg/rely-evaluate.png" style="height: auto;width: 9.875rem;min-width: 9.875rem">
                </mu-carousel-item>
                <mu-carousel-item>
                    <div  class="page-info">
                        <h2 class="fadeInUp" :style="pageh2">玩转社交电商，解锁多种盈利方式</h2>
                        <h3 class="fadeInUp2" style="color: rgb(156, 158, 174);text-align: left;" :style="pageh3">鼓励会员主动分享传播，一次锁定会员多次盈利，提升商城复购率</h3>
                    </div>
                    <img src="/site_static/pimg/do-well.png" style="height: auto;width: 9.875rem;min-width: 9.875rem">
                </mu-carousel-item>
            </mu-carousel>
        </div>

        <div class="fooder">
            <div class="logo">
                <img src="../../../assets/phoneimg/nav_logo.png" alt="">
            </div>
            <div class="body">
                <ul>
                    <li>国际顶级域名</li>
                    <li>出版物经营许可证</li>
                    <li>广播电视节目制作经营许可证</li>
                    <li>开户许可证</li>
                    <li>食品经营许可证</li>
                    <li>计算机软件著作权证书</li>
                    <li>网络文化经营许可证</li>
                    <li>营业执照</li>
                    <li>增值电信业务许可证</li>
                </ul>
            </div>
            <div class="last">
                <span>微涟科技有限公司版权所有</span>
                <span>©辽ICP备18009739号</span>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'pzhuangxiu',
        data(){
            return{
                briefwordstyle:{},
                briefimg:{},
                pageh3:{},
                pageh2:{},
                lunboleft:14,
                lunboact:['lunact','','',''],
                la:['la','','',''],
                lunindex:0
            }
        },
        created() {
            let self = this
            setTimeout(function () {
                self.briefwordstyle = {
                    opacity: 1,
                    bottom: '3rem'
                }
                self.briefimg = {
                    opacity: 1,
                    bottom: '1rem'
                }
                self.pageh2 = {
                    opacity: 1,
                    bottom: 0
                }
                self.pageh3 = {
                    opacity: 1,
                    bottom: 0
                }
            }, 0)
        }
    }
</script>
<style scoped>
    h2 , h3 {
        margin: 0;
    }
    ul{
        list-style: none;
        padding: 0;
    }
    .pjiejue{
        margin-top: 3rem;
    }
    .brief-bg{
        width: 100%;
        height: 10.9375rem;
        position: relative;
        background: #49daae;
        overflow: hidden;
    }
    .brief-bg>.brief-bg__word{
        position: absolute;
        width: 11.25rem;
        left: 1.25rem;
        bottom: 0rem;
        color: #fff;
        opacity: 0;
        transition: all .5s;
    }
    .brief-bg>.brief-bg__word>h2{
        line-height: 1.125rem;
        font-weight: 600;
        font-size: 1.125rem;
        color: #fff;
        margin-bottom: 1.25rem;
    }
    .brief-bg>.brief-bg__word>span {
        font-size: .75rem;
        color: hsla(0,0%,100%,.8);
        line-height: 1.3125rem;
    }
    .brief-bg>img{
        width: 8.0625rem;
        position: absolute;
        bottom: 0rem;
        right: 1.25rem;
        opacity: 0;
        transition: all .5s;
    }
    .page-info>h2 {
        margin: 2.5rem auto .4375rem;
        text-align: center;
        font-size: 1.0625rem;
        font-weight: 600;
        line-height: 1.0625rem;
        color: #5d6494;
        position: relative;
        bottom: -2rem;
        -webkit-transition: all .5s;
        transition: all .5s;
        opacity: 0;
    }
    .page-info>h3 {
        width: 18.6875rem;
        margin: auto;
        text-align: center;
        font-size: .75rem;
        line-height: 1.3125rem;
        color: #9c9eae;
        font-weight: 400;
        position: relative;
        transition: all 1s;
        bottom: -1rem;
    }
    .page-info>ul{
        width: 100%;
        display: flex;
        justify-content: center;
        margin: 1.875rem 0 2.1875rem;
        list-style: none;
        padding: 0;
    }
    .page-info>ul>li{
        box-shadow: 0 0.125rem 0.4375rem rgba(0,0,0,.08);
        width: 6.59375rem;
        height: 9.125rem;
        background: #fff;
        position: relative;
        margin: 0 .28125rem;
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
    }
    .page-info>ul>li>img{
        width: 2.4375rem;
        margin-top: 1.125rem;
        height: 2.40625rem;
    }
    .page-info>ul>li>h4{
        font-size: .8125rem;
        color: #3b426b;
        line-height: .8125rem;
        top: 4.6875rem;
        font-weight: 600;
        width: 100%;
    }
    .page-info>ul>li>span{
        font-size: .75rem;
        color: #7b88a2;
        line-height: 1.21875rem;
        top: 6rem;
        transform: scale(.9);
    }
    .page-info {
        width: 100%;
        position: relative;
        overflow: hidden;
    }
    .wake {
        position: relative;
        width: 100%;
        height: 21.875rem;
        overflow: hidden;
        background-color: #fff;
    }
    .wake img{
        display: block;
        margin: 1.5625rem auto;
        width: 20.9375rem;
    }
    .distribute-model {
        width: 100%;
        background: #fafafa;
    }
    .distribute-model>.distribute-model__list {
        width: 100%;
        overflow: hidden;
        box-sizing: border-box;
        display: flex;
        flex-wrap: wrap;
        padding: 0 0 1.4375rem 1.25rem;
        margin-top: 1.5625rem;
    }
    .distribute-model>.distribute-model__list>.distribute-model__list__item {
        width: 10.09375rem;
        height: 8.875rem;
        background: #fff;
        border-radius: .3125rem;
        position: relative;
        margin: 0 .75rem .75rem 0;
    }
    .distribute-model>.distribute-model__list>.distribute-model__list__item>img {
        position: relative;
        top: 1.25rem;
        left: 0;
        right: 0;
        margin: auto;
        width: 2.75rem;
        height: 2.75rem;
    }
    .distribute-model>.distribute-model__list>.distribute-model__list__item>h4{
        color: #3b426b;
        top: 5.25rem;
        font-size: .8125rem;
        line-height: .8125rem;
        margin-top: 2rem;
    }
    .distribute-model>.distribute-model__list>.distribute-model__list__item>span{
        color: #7e8da9;
        top: 6.90625rem;
        font-size: .6875rem;
        line-height: .6875rem;
    }
    .fooder{
        width: 100%;
        overflow: hidden;
        background: #1c1c24;
        position: relative;
    }
    .logo{
        width: 20.9375rem;
        margin: auto;
        height: 4.96875rem;
        position: relative;
        margin-left: 2rem;
    }
    .logo>img{
        width: 14.25rem;
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
        height: auto;
    }
    .body{
        width: 100%;
        box-sizing: border-box;
        margin: auto;
    }
    .body>ul{
        width: 100%;
        margin-bottom: 1.5rem;
        overflow: hidden;

    }
    .body li{
        margin: 0 1.1875rem 0 0;
        font-size: .75rem;
        color: #888;
        line-height: .75rem;
        width: calc(33% - 1rem);
        float: left;
        margin:  .5rem;
    }
    .last{
        width: 20.9375rem;
        margin: auto;
        height: 4.125rem;
        box-sizing: border-box;
        border-top: 1px solid hsla(0,0%,100%,.1);
        padding: 1.125rem 0 0 0;
        margin-bottom: 3rem;
    }
    .last>span{
        display: block;
        font-size: .625rem;
        color: #3d404d;
        line-height: 1rem;
        text-align: center;
    }



</style>



// WEBPACK FOOTER //
// src/components/phone/ppro/pjiejue.vue